import { BotProviderType, MediaUrl, postApiBotProviderActionsSend } from "@/API";

export function useBotProviderSendMessage(props: { provider: BotProviderType, workspaceId: string, botProviderId: string, userId: string }) {
    return async (texts: string[], mediaUrls?: MediaUrl[]) => {
        await postApiBotProviderActionsSend({
            texts: texts,
            mediaUrls: mediaUrls
        }, {
            workspaceId: props.workspaceId,
            botProviderId: props.botProviderId,
            userId: props.userId
        })
    }
}